


















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class CountTextArea extends Vue {
  @Prop({ default: "" }) value!: string;
  @Prop({ default: 0 }) maxLength!: number;
  @Prop({ default: true }) hideCount!: boolean;

  localValue: string = this.value;

  updateValue(event: Event) {
    this.$emit("input", (event.target as HTMLTextAreaElement).value);
  }

  @Watch("value")
  onValueChanged(newVal: string) {
    this.localValue = newVal;
  }

  /** 入力文字数テキスト */
  private get CounterText(): string {
    let counterText = String(this.localValue.length);
    if (!this.hideCount && this.maxLength > 0) {
      counterText += ` / ${this.maxLength}`;
    }
    return counterText;
  }
}
